module.exports = __webpack_public_path__ + "6fd47f02a8db8a6cadf9f5138495e49e.png";